const manualList = () => import('@/pages/content/manual/index.vue');
const manualForm = () => import('@/pages/content/manual/form.vue');

export default [{
    path: '/content/manual',
    component: manualList,
    meta: [{
        name: '内容管理'
    },
    {
        name: '电子说明书管理',
        activeRoute: '/content/manual'
    }]
}, {
    path: '/content/manual/form',
    component: manualForm,
    meta: [{
        name: '内容管理'
    }, {
        name: '电子说明书管理',
        url: '/content/manual'
    }, {
        name: '新增/编辑',
        activeRoute: '/content/manual'
    }]
}];